import { Notyf } from 'notyf';

/**
 * Notyf
 * @description Create a new instance of Notyf
 * @see https://github.com/caroso1222/notyf
 */
const notyf = new Notyf({
  duration: 5000,
  ripple: false,
  dismissible: true,
  position: {
    x: 'center',
    y: 'bottom',
  },
});

export { notyf };
